module.exports = __webpack_public_path__ + "files/6e5ffaeaaeb4bb49043e782a658ccbee.png";